import { useEffect, useState } from "react";
import { Form, message } from "antd";
import dayjs from "dayjs";
import { SDrawerOrModal, SGeneralForms } from "shj-components";
import { productCombinationEdit } from "@/services/product.ts";

const EditModal = (props) => {
  const { open, onClose, onReload, record = {}, query = {} } = props;
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)
  const [isEditStartDate, setIsEditStartDate] = useState(false)
  const startDate = Form.useWatch('startDate', form)

  useEffect(() => {
    if(open){
      form.resetFields()
      form.setFieldsValue({
        ...record,
        startDate: record.startDate ? dayjs(record.startDate) : null,
        endDate: record.endDate ? dayjs(record.endDate) : null,
      })
      setIsEditStartDate(dayjs(record.startDate) && dayjs(record.startDate) < dayjs().add(1, 'day').startOf('day'))
    }
  }, [open]);

  const disabledEndDate = (current) => {
    const date = startDate || dayjs(record.startDate);
    return current && current < date.startOf('day')
  }

  const onFinish = () => {
    form.validateFields().then((values => {
      setLoading(true)
      const startDate = values.startDate ? values.startDate.format('YYYY-MM-DD') : undefined;
      const endDate = values.endDate ? values.endDate.format('YYYY-MM-DD') : undefined;
      productCombinationEdit({...record, ...values, startDate, endDate })
        .then(res => {
          message.success(res.message || '操作成功');
          onClose?.()
          onReload?.()
        }).finally(() => setLoading(false))
    }))
  }

  return <>
    <SDrawerOrModal
      title={'编辑'}
      mode="modal"
      width={500}
      open={open}
      loading={loading}
      onCancel={onClose}
      onOk={onFinish}
    >
      <SGeneralForms
        formConfig={{ form }}
        configs={[{
          formItem: [
            { name: 'id', hidden: true},
            {
              spanCol: 24,
              label: '开始日期',
              name: 'startDate',
              required: true,
              rules: [{ required: true, message: '开始日期不能为空' }],
              type: 'date',
              comConfig: {
                disabled: isEditStartDate,
                disabledDate: (current) => {
                  return current && current < dayjs().startOf('day');
                }
              }
            },
            {
              spanCol: 24,
              label: '结束日期',
              name: 'endDate',
              type: 'date',
              comConfig: {
                disabledDate: disabledEndDate,
              }
            },
            {
              spanCol: 24,
              label: '附图顺序',
              tooltip: '通过填写数字指定子产品SPU图片附图给组合SPU图片的顺序，空则代表不附给组合',
              name: 'picSort',
              type: 'inputNumber',
              comConfig: {
                min: 1,
                max: 999999999,
                precision: 0,
              }
            }
          ]
        }]}
      />
    </SDrawerOrModal>
  </>
}

export default EditModal